export default __webpack_public_path__ + "static/media/five-image.917d5ee0.png";